import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { closeAdvancedSettings } from "../_actions/sidebarSliderActions";
import {
  StyledArtBoardFooter,
  StyledArtboardFooterContentContainer,
  StyledArtBoardFooterWithBottomPanel,
} from "../_components/styled/details/styleArtBoardEditor";
import ArtBoardRearrangePanel from "./ArtBoardRearrangePanel";
import ArtBoardsLeftFooter from "./ArtBoardsLeftFooter";
import ArtBoardsMiddleFooter from "./ArtBoardsMiddleFooter";
import ArtBoardsRightFooter from "./ArtBoardsRightFooter";
import StudioBottomPanel from "./StudioBottomPanel";
import TimelineEditor from "./TimelineEditor";
import { TimelineContext } from "../_utils/timeline";
import { BottomPanelViewTypes, StoryTypes } from "../_utils/constants";
import ExpandedMusicPlayerTimeline from "./ExpandedMusicPlayerTimeline";
import { openBottomPanel } from "../_actions/bottomPanelActions";
import StudioEditorToolbar from "../_components/details/editorToolbar/commonEditorToolbar/StudioEditorToolbar";
import ArtBoardHandler from "../_components/common/artBoardHandlers/ArtBoardHandler";
import { StudioRightSidePanel } from "../_components/details/StudioRightSidePanel";
import Drawer from "react-bottom-drawer-custom";
import { vhToPixel } from "../_utils/common";
import { StyledArtboardBottomDrawer } from "../_components/styled/styles";
import { FaEllipsisH } from "react-icons/fa";
import { Box, Flex } from "@chakra-ui/react";
import { selectArtboard } from "../_actions/motionActions";

class ArtBoardFooter extends Component {
  static contextType = TimelineContext;

  state = {
    renderData: false,
  };

  onClickBottombar = (e) => {
    const { openBottomPanel } = this.props;
    if (e.target?.dataset?.click) {
      openBottomPanel(BottomPanelViewTypes.PREVIEW_ARTBOARDS);
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps?.selectedArtboard?.id !== this.props?.selectedArtboard?.id) {
      // TODO: Fix this (For now after component updates we check for artboard id if it's changed then render the content)
      this.setState(
        {
          renderData: false,
        },
        () => {
          setTimeout(() => {
            this.setState({
              renderData: true,
            });
          }, 1);
        }
      );
    }
  }

  componentWillUnmount() {
    const { selectArtboard } = this.props;
    selectArtboard();
  }

  render() {
    const {
      isActionPanelOpen,
      isSliderOpen,
      isBottomPanelOpen,
      canvasRef,
      zoomRatio,
      isStoryAnimated,
      bottomPanelViewType,
      openBottomPanel,
      rightsidebar,
      editor,
      selectedArtboard,
    } = this.props;
    const { renderData } = this.state;

    const { activeElement } = editor;

    const artBoardHandler = new ArtBoardHandler(canvasRef?.handler);

    let renderBottomPanel = null;
    if (isBottomPanelOpen) {
      switch (bottomPanelViewType) {
        // If the bottom panel is preview artboards
        case BottomPanelViewTypes.PREVIEW_ARTBOARDS:
          renderBottomPanel = isStoryAnimated ? (
            <TimelineEditor canvasRef={canvasRef} />
          ) : (
            <StudioBottomPanel canvasRef={canvasRef} />
          );
          break;

        // Fullscreen preview
        case BottomPanelViewTypes.ARTBOARDS_GRID_VIEW:
          renderBottomPanel = <ArtBoardRearrangePanel canvasRef={canvasRef} />;
          break;

        // Trim story music
        case BottomPanelViewTypes.TRIM_STORY_MUSIC:
          renderBottomPanel = (
            <ExpandedMusicPlayerTimeline
              isSliderOpen={isSliderOpen === "open"}
              onClose={() => {
                openBottomPanel(BottomPanelViewTypes.PREVIEW_ARTBOARDS);
              }}
            />
          );
          break;
        default:
          renderBottomPanel = null;
      }
    }

    if (isActionPanelOpen && this.props.isMobileView) {
      renderBottomPanel = (
        <div className="no-scrollbar studio-right-side-panel">
          <StudioRightSidePanel
            artBoardHandler={artBoardHandler}
            canvasRef={canvasRef}
            isActionPanelOpen={isActionPanelOpen}
            rightsidebar={rightsidebar}
          />
        </div>
      );
    }

    let content = (
      <StyledArtBoardFooterWithBottomPanel
        isActionPanelOpen={isActionPanelOpen}
        isSliderOpen={isSliderOpen}
        isBottomPanelOpen={isBottomPanelOpen}
        fullheight={
          !!(
            isBottomPanelOpen &&
            bottomPanelViewType === BottomPanelViewTypes.PREVIEW_ARTBOARDS &&
            isStoryAnimated &&
            selectedArtboard?.id
          )
        }
      >
        {!isBottomPanelOpen && !(this.props.isMobileView && isActionPanelOpen) && (
          <Flex direction="column">
            {!(this.props.isMobileView && activeElement.mime) && (
              <StyledArtBoardFooter
                className={"tldr-editor-footer"}
                isActionPanelOpen={isActionPanelOpen}
                isSliderOpen={isSliderOpen}
                isBottomPanelOpen={isBottomPanelOpen}
                onClick={this.onClickBottombar}
                data-click
              >
                <ArtBoardsLeftFooter
                  canvasRef={canvasRef}
                  zoomRatio={zoomRatio}
                  isBottomPanelOpen={isBottomPanelOpen}
                  bottomPanelViewType={bottomPanelViewType}
                />
                <Box display={["none", "none", "flex", "flex"]}>
                  <ArtBoardsMiddleFooter canvasRef={canvasRef} />
                </Box>
                <Flex
                  display={["none", "none", "flex", "flex"]}
                  style={{ flex: "1 1 0%" }}
                >
                  <ArtBoardsRightFooter
                    canvasRef={canvasRef}
                    zoomRatio={zoomRatio}
                  />
                </Flex>
              </StyledArtBoardFooter>
            )}
            {this.props.isMobileView ? (
              <StudioEditorToolbar
                canvasRef={canvasRef}
                artBoardHandler={artBoardHandler}
              />
            ) : (
              <></>
            )}
          </Flex>
        )}
        {renderBottomPanel}
      </StyledArtBoardFooterWithBottomPanel>
    );

    return isBottomPanelOpen &&
      bottomPanelViewType === BottomPanelViewTypes.PREVIEW_ARTBOARDS &&
      isStoryAnimated &&
      selectedArtboard?.id ? (
      <StyledArtboardBottomDrawer>
        <Drawer
          className="drawer"
          isVisible={true}
          drawerHeight={vhToPixel(20)}
          drawerMinHeight={vhToPixel(15)}
          drawerMaxHeight={vhToPixel(50)}
          handle={<FaEllipsisH className="handle" />}
          hideScrollbars="false"
          onClose={() => {}}
        >
          <StyledArtboardFooterContentContainer>
            {renderData ? content : <></>}
          </StyledArtboardFooterContentContainer>
        </Drawer>
      </StyledArtboardBottomDrawer>
    ) : (
      content
    );
  }
}

ArtBoardFooter.propTypes = {
  story: PropTypes.object,
  isBottomPanelOpen: PropTypes.bool,
  bottomPanelViewType: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isStoryAnimated: state.story?.payload?.story_type === StoryTypes.ANIMATED,
  editor: state.editor,
  rightsidebar: state.rightsidebar,
  isMobileView: state.app.isMobileView,
  selectedArtboard: state.motionStore?.selectedArtboard,
});

const mapDispatchToProps = (dispatch) => ({
  openBottomPanel: (panelType) => dispatch(openBottomPanel(panelType)),
  closeAdvancedSettings: () => dispatch(closeAdvancedSettings()),
  selectArtboard: () => dispatch(selectArtboard()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArtBoardFooter);
